import { createBv } from '@bv/plugins';
import { messages as aiMessages } from '@bvai/locale';
import { createApp } from 'vue';
import VueApexCharts from 'vue3-apexcharts';
import VueClickAway from 'vue3-click-away';

import 'vue3-toastify/dist/index.css';
import { initBvai } from '@/bvai.config';
import components from '@/components/shared/components';
import { vObserveVisibility } from '@/directives';
import { permissionHelper } from '@/helpers/auth/permissions.helper';
import NotificationsSocket from '@/helpers/notifications/socket';
import conversationsSocket from '@/helpers/socket/socket';
import { messages, pluralizationRules } from '@/locale';
import pinia from '@/plugins/pinia';
import vuetify from '@/plugins/vuetify';

import App from './App.vue';
import { mainRoute, modules } from './router';

initBvai();

import '@/assets/sass/_main.scss';

const app = createApp(App);

const bv = createBv({
  i18n: {
    messages: [messages, aiMessages],
    pluralizationRules,
  },
  sip: {
    connection: false,
  },
  pinia,
  mainRoute,
  sidebar: {
    modules,
  },
});
app.use(bv);

// apexcharts configuration
app.use(VueApexCharts as any);

// global components configuration
components.install(app);

// Vuetify configuration
app.use(vuetify);

// import custom directives
app.directive('observe-visibility', vObserveVisibility);

// Click Away configuration
app.use(VueClickAway);

// Attach conversations socket to global properties
app.config.globalProperties.$conversationsSocket = conversationsSocket;
app.config.globalProperties.$notificationsSocket = NotificationsSocket;

// Attach permissions helper to global properties
app.config.globalProperties.$permissionHelper = permissionHelper;

// for animation
import 'animate.css';

app.mount('#app');
